var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sellpactseal-check',{attrs:{"sna-id":_vm.snaId,"pagetitle":"销售退货合同盖章审批详情"}})}
var staticRenderFns = []

export { render, staticRenderFns }